import { render, staticRenderFns } from "./controlSalesGoodsDialog.vue?vue&type=template&id=4b5c843e"
import script from "./controlSalesGoodsDialog.vue?vue&type=script&lang=js"
export * from "./controlSalesGoodsDialog.vue?vue&type=script&lang=js"
import style0 from "./controlSalesGoodsDialog.vue?vue&type=style&index=0&id=4b5c843e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5c843e')) {
      api.createRecord('4b5c843e', component.options)
    } else {
      api.reload('4b5c843e', component.options)
    }
    module.hot.accept("./controlSalesGoodsDialog.vue?vue&type=template&id=4b5c843e", function () {
      api.rerender('4b5c843e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/goodsManage/components/controlSalesGoodsDialog.vue"
export default component.exports